import Env from '../base/env.js'
import Channels from '../base/channels.js'
import gsap from '../vendor/gsap-new/gsap'
import hoverIntent from 'hoverintent'
import Hammer from 'hammerjs'

class MainnavTouch
{
    constructor()
    {
        this.view = Env.$mainNav
        this.$triggers = Env.$body.querySelectorAll('.jsMainnav--trigger')
        this.$subnavTriggers = document.body.querySelectorAll('.jsSubnav-trigger')
        this.$subnavElements = document.body.querySelectorAll('.jsSubnav')
        this.$subnavItemsTriggers = document.body.querySelectorAll('.jsSubnavItem--trigger')
        this.$subnavItemsReceptors = document.body.querySelectorAll('.jsSubnavItem--receptor')

        this.hammerInstances = []
        for(let subnav of this.$subnavElements) {
            const hammerView = new Hammer(subnav)
            hammerView.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });
            this.hammerInstances.push(hammerView)
        }


        this.zIndex = 20
        this.zIndexHover = 1

        // Flags
        this.IS_ANIMATING = false
        // Fns
        this.events()
    }
    events()
    {
        var
        self = this

        for ( const e of this.$triggers ) {
            e.addEventListener('click',()=>{
                if(this.IS_ANIMATING == false)
                {
                    this.toggle()
                }
                return false;
            },false)
        }

        Channels.on('mainnav::close',()=>
        {
            this.close()
        })

        Channels.on('window::smartresize',()=>{
            if(Env.mobileCSS === false)
            {
                if(this.view != null) {
                    this.view.removeAttribute('style')
                }
            }
        })

        if(Env.mobileCSS) {
            for(let hammer of this.hammerInstances) {
                hammer.on('swipedown' , (ev)=>
                {
                    this.closeSubnavMobile()
                })
            }

            this.clickSubnav()
        } else {
            this.hoverSubnav()
            this.hoverBackgrounds()
        }
    }

    closeSubnavMobile()
    {
        for ( const el of this.$subnavTriggers ) {
            const DOM = {}
            DOM.subnav = el.querySelector('.jsSubnav')
            el.classList.remove('is-active')
            DOM.subnav.classList.remove('is-opened')
            Env.$html.classList.remove('subnavMobile--isOpened')
            gsap.to(
                DOM.subnav,
                {
                    y:'100%',
                    ease:'quint.out',
                    duration:.6,
                    onComplete:()=>{
                    gsap.set(DOM.subnav,{ display:'none' })
                    }
                }
            )
        }
    }

    clickSubnav()
    {
      for ( const el of this.$subnavTriggers ) {
        const DOM = {}
        DOM.subnav = el.querySelector('.jsSubnav')
        el.addEventListener('click',(e)=>{

         if(e.target.classList.contains('jsToFollow') == false) {
            e.preventDefault()
            this.zIndex++
            if(DOM.subnav.classList.contains('is-opened') == false) {
                DOM.subnav.classList.add('is-opened')
                el.classList.add('is-active')
                Env.$html.classList.add('subnavMobile--isOpened')
                for(let otherSubnav of this.$subnavElements) {
                    if(otherSubnav != DOM.subnav) {
                        otherSubnav.classList.remove('is-opened')
                        otherSubnav.parentElement.classList.remove('is-active')
                        gsap.to(otherSubnav,
                        {
                            y:'100%',
                            duration:.4,
                            ease:'quint.out'
                        })
                    }
                }
                gsap.fromTo(
                  DOM.subnav,
                  {
                    display:'block',
                    y:'100%',
                    zIndex:this.zIndex
                  },
                  {
                    y:0,
                    ease:'quint.out',
                    duration:.6,
                  }
                )
              } else {
                el.classList.remove('is-active')
                DOM.subnav.classList.remove('is-opened')
                Env.$html.classList.remove('subnavMobile--isOpened')
                gsap.to(
                    DOM.subnav,
                    {
                      y:'100%',
                      ease:'quint.out',
                      duration:.6,
                      onComplete:()=>{
                        gsap.set(DOM.subnav,{ display:'none' })
                      }
                    }
                  )
              }
            }
        })
      }
    }

    hoverBackgrounds()
    {

        for(let i = 0; i < this.$subnavItemsTriggers.length; i++ ) {
            if(typeof this.$subnavItemsReceptors[i] != 'undefined') {
                const $trigger = this.$subnavItemsTriggers[i]
                const $receptor = this.$subnavItemsReceptors[i]
                const $fill = this.$subnavItemsReceptors[i].parentElement.parentElement.parentElement.querySelector('.fill')
                const number = $trigger.getAttribute('data-hover')
                const skin = $trigger.getAttribute('data-skin')
                const klass = 'jsSubnavItem--receptor--'+number
                $trigger.addEventListener('mouseenter',()=>{
                    // Env.$html.classList.remove('subnavHover--white')
                    // Env.$html.classList.remove('subnavHover--dark')
                    // Env.$html.classList.add('subnavHover--'+skin)
                    // gsap.to(
                    //     $fill,
                    //     {
                    //         backgroundColor:$trigger.getAttribute('data-bg'),
                    //         duration:.5,
                    //         ease:'cubic.out'
                    //     }
                    // )
                    gsap.fromTo(
                        $receptor,
                        {
                            autoAlpha:0,
                            zIndex:this.zIndexHover
                        },
                        {
                            autoAlpha:1,
                            duration:.5,
                            ease:'cubic.out'
                        }
                    )
                    this.zIndexHover++
                })
            }
        }
        for(let subnav of this.$subnavElements)
        {
            const $fill = subnav.querySelector('.fill')
            subnav.addEventListener('mouseleave',()=>{
                // Env.$html.classList.remove('subnavHover--white')
                // Env.$html.classList.remove('subnavHover--dark')
                gsap.fromTo(
                    subnav.querySelector('.visuals .bg.is-init'),
                    {
                        autoAlpha:0,
                        zIndex:this.zIndexHover
                    },
                    {
                        autoAlpha:1,
                        duration:.5,
                        ease:'cubic.out'
                    }
                )
                gsap.set(this.$subnavItemsReceptors, { clearProps: 'z-index'})
                // gsap.to(
                //     $fill,
                //     {
                //         backgroundColor:'#fff',
                //         duration:.5,
                //         ease:'cubic.out'
                //     }
                // )
            })
        }
    }

    hoverSubnav()
    {
      for ( const el of this.$subnavTriggers ) {
        const DOM = {}
        DOM.subnav = el.querySelector('.jsSubnav')
        DOM.subnavContent = DOM.subnav.querySelector('.subnav')
        DOM.fill = DOM.subnav.querySelector('.fill')

        hoverIntent(el,
          ()=> {
            Env.$html.classList.add('subnav--isOpened')
            el.classList.add('is-active')
            const tl = gsap.timeline()

            tl.fromTo(
              DOM.subnav,
              {
                // display:'block',
                autoAlpha:0
              },
              {
                autoAlpha:1,
                ease:'cubic.out',
                duration:.01
              }
            )
            Env.$html.classList.remove('subnavHover--white')
            Env.$html.classList.remove('subnavHover--dark')
            Env.$html.classList.add('subnavHover--'+el.getAttribute('data-skin'))
            gsap.to(
                DOM.fill,
                {
                    backgroundColor:el.getAttribute('data-bg'),
                    duration:.2,
                    ease:'cubic.out'
                }
            )
            // .fromTo(
            //     DOM.subnavContent,
            //     {
            //         autoAlpha:0
            //     },
            //     {
            //         autoAlpha:1,
            //         duration:.3,
            //         ease:'cubic.out'
            //     }
            // )
          }, ()=> {
            Env.$html.classList.remove('subnav--isOpened')
            el.classList.remove('is-active')
            Env.$html.classList.remove('subnavHover--white')
            Env.$html.classList.remove('subnavHover--dark')
            const tl = gsap.timeline()



            tl
            // .to(
            //     DOM.subnavContent,
            //     {
            //         autoAlpha:0,
            //         duration:.3,
            //         ease:'cubic.out'
            //     }
            // )
            .to(
              DOM.subnav,
              {
                autoAlpha:0,
                ease:'cubic.out',
                duration:.01,
                onComplete:()=>{
                //   gsap.set(DOM.subnav,{ display:'none' })
                }
              }
            )
          }).options({
            timeout: 10,
            interval: 10
          });
      }
    }

    getStatus()
    {
        return this.view.classList.contains('is--active')
    }

    close(funcStart=null,funcComplete=null)
    {
        this.out(
            ()=>{
                this.IS_ANIMATING = true
                this.view.classList.remove('is--active');
                Env.$html.classList.remove('mainnav--isOpened')
                Env.$html.classList.add('mainnav--isLeaving')
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            ()=>{
                this.IS_ANIMATING = false
                Env.$html.classList.remove('mainnav--isLeaving')
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        )
    }

    in(funcStart='',funcComplete='')
    {

        let timeline = new TimelineLite({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'in'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
            TweenLite.fromTo(this.view , .5,
                {
                    y : '-100%'
                },
                {
                    y: "0%",
                    ease: Cubic.easeOut,
                    delay: 0
                }
            ),
        ])
    }

    out(funcStart='',funcComplete='')
    {

        let timeline = new TimelineLite({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
                this.status = 'out'
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        timeline.add([
            TweenLite.to(this.view , .5,
                {
                    y: "-100%",
                    ease: Cubic.easeOut,
                    delay: 0
                }
            ),
        ])

    }

    toggle(_status)
    {
        if (typeof _status === 'undefined')
            _status = this.view.classList.contains('is--active')

        if(!!_status)
        {
            this.close()
        }
        else
        {
            this.in(
                ()=>{
                    this.IS_ANIMATING = true
                    this.view.classList.add('is--active');
                    Env.$html.classList.add('mainnav--isOpened')
                },
                ()=>{

                    this.IS_ANIMATING = false
                }
            )
        }
    };
}

export default MainnavTouch;